import React from "react";
import "@styles/components/ui/Footer.scss";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";
import LanguageIcon from "@mui/icons-material/Language";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
const Footer = () => {
  const { t, i18n } = useTranslation();
  const toggleLang = () => {
    const newLang = i18n.language === "hk" ? "hk_en" : "hk";
    i18n.changeLanguage(newLang);
  };
  const isChinese = i18n.language === "hk";
  const navigate = useNavigate();

  return (
    <Box className="footer-container">
      <Box className="footer-detail-container">
        <Typography className="copyright">
          <Trans
            i18nKey="footer:copyright"
            values={{ year: new Date().getFullYear() }}
          />
        </Typography>
        <Box className="border-line"></Box>
        <Box className="bottom-container">
          {/* <Box className="lang-container" onClick={toggleLang}>
            <Trans i18nKey="footer:lang" />{" "}
            <LanguageIcon className="lang-icon" />
          </Box> */}
          <Box className="terms-container">
            <a
              href={
                isChinese
                  ? "https://www.samsung.com/hk/info/privacy/"
                  : "https://www.samsung.com/hk_en/info/privacy/"
              }
              target="_blank"
              className="terms"
            >
              <Trans i18nKey="footer:privacy" />
            </a>
            <a
              href={
                isChinese
                  ? "https://www.samsung.com/hk/info/legal/"
                  : "https://www.samsung.com/hk_en/info/legal/"
              }
              target="_blank"
              className="terms"
            >
              <Trans i18nKey="footer:terms" />
            </a>
            <span
              onClick={() => {
                navigate("/tnc");
              }}
              target="_blank"
              className="terms"
            >
              <Trans i18nKey="footer:member_policy" />
            </span>{" "}
            <span
              onClick={() => {
                navigate("/faq");
              }}
              target="_blank"
              className="terms"
            >
              <Trans i18nKey="footer:faq" />
            </span>
          </Box>
          <Box className="media-container">
            <a
              href="https://api.whatsapp.com/send/?phone=85236984698&text=Subscribe+to+Samsung+HK+WhatsApp+%E8%A8%82%E9%96%B1+Samsung+HK+WhatsApp&type=phone_number&app_absent=0"
              target="_blank"
            >
              <WhatsAppIcon className="media" />
            </a>
            <a href="https://www.facebook.com/SamsungHK" target="_blank">
              <FacebookIcon className="media" />
            </a>
            <a href="https://www.instagram.com/samsung_hk/" target="_blank">
              <InstagramIcon className="media" />
            </a>
            <a
              href="https://www.youtube.com/user/SamsungHongKong"
              target="_blank"
            >
              <YouTubeIcon className="media" />
            </a>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
